import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'keyValue'
})
export class keyValuePipe {
  transform(value: any, arg: string = null): any {
    if (value) {
      let keys;
      if (arg == "reverse") {
        keys = Object.keys(value).reverse();
      }
      else {
        keys = Object.keys(value)
      }
      return keys.map(function (key) {
        let pair = {};
        let k = 'key';
        let v = 'value'
        pair[k] = key;
        pair[v] = value[key];
        return pair;
      });
    }
    else {
      return [];
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/common/utils/pipes/keyvalue.pipe.ts